import { css } from "@emotion/core"
import { theme } from "../constants"

export const inputStyles = (hasError, icon) => css`
  ${theme.presets.flexColumn};
  width: 100%;
  max-height: 44px;
  padding: 9px 20px;
  background-color: ${theme.colors.purple[800]} !important;
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fontSizes[4]};
  border-radius: ${theme.radii[11]};
  border: 1px solid ${hasError ? theme.colors.danger : theme.colors.purple[800]};
  box-shadow: ${theme.shadows.regular};
  .ant-picker-input > input {
    color: ${theme.colors.text};
  }
  .anticon-calendar {
    color: ${theme.colors.text};
    cursor: pointer;
    display: ${icon === "none" ? "none" : "inherit"};
  }
  .ant-picker-clear {
    background-color: ${theme.colors.purple[800]};
    color: ${theme.colors.text};
    &:hover {
      color: ${theme.colors.text};
    }
  }
  &:hover,
  &:focus,
  &:active {
    border: ${hasError ? "1px solid #EF4E4E !important" : "none !important"};
    box-shadow: ${theme.shadows.regular} !important;
  }

  &::placeholder {
    color: ${theme.colors.grey[400]};
  }
`
export const dateContainerStyle = css`
  position: relative;
  font-family: ${theme.fonts.primary};
  ${theme.presets.flexColumn};
  ${theme.presets.flexXYCentered};

  .ant-picker.ant-picker-disabled {
    opacity: 0.3;
    background: ${theme.colors.purple[900]} !important;
    color: ${theme.colors.text} !important;
    border: none;
    box-shadow: none;
    &:hover {
      border: none;
    }
  }
  .error-text {
    margin-top: 8px;
    margin-left: 4px;
    text-align: left;
    width: 95%;
  }
`
export const bgStyle = css`
  height: 50vh;
  width: 80vw;
  background: #493988;
  padding: 1em;
`
